import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe that truncates a SoC (State of Charge) value to 1 decimal place without rounding.
 * For example: 96.99 becomes 96.9, not 97.0
 *
 * This is to prevent rare cases where a rounded value might fall within a tolerance threshold when the actual value does not.
 */
@Pipe({
    name: 'truncateSoC',
    standalone: true,
})
export class TruncateSoCPipe implements PipeTransform {
    /**
     * Transforms a SoC value to a truncated string with 1 decimal place
     *
     * @param value The SoC value to truncate, can be a number or a string representation of a number.
     * @returns The truncated SoC value as a string with 1 decimal place, or an empty string if the input is invalid.
     */
    transform(value: number | string | undefined | null): string {
        if (value === undefined || value === null || value === '') {
            return '';
        }

        const numValue = typeof value === 'string' ? parseFloat(value) : value;

        if (isNaN(numValue)) {
            return '';
        }

        // Multiply by 10, truncate using Math.trunc, then divide by 10
        const truncated = Math.trunc(numValue * 10) / 10;
        return truncated.toFixed(1);
    }
}
